import { render, staticRenderFns } from "./Hazard.vue?vue&type=template&id=cc11822a&"
import script from "./Hazard.vue?vue&type=script&lang=js&"
export * from "./Hazard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports